const screen = (width, op = 'min') => `screen and (${op}-width: ${width})`;
export const PHONE_BP = screen('424px', 'max');
export const TABLET_BP = screen('425px');
export const LAPTOP_BP = screen('768px');
export const DESKTOP_BP = screen('1024px');
export const WIDESCREEN_BP = screen('1440px');
export const phone = () => window.matchMedia(PHONE_BP).matches;
export const tablet = () => window.matchMedia(TABLET_BP).matches;
export const laptop = () => window.matchMedia(LAPTOP_BP).matches;
export const desktop = () => window.matchMedia(DESKTOP_BP).matches;
export const widescreen = () => window.matchMedia(WIDESCREEN_BP).matches;
